import { createBrowserHistory } from "history";

/**
 * Creates shared browser history for use by React Router and Redux store
 */
const history = createBrowserHistory();

export default history;
